// extracted by mini-css-extract-plugin
module.exports = {"faCheckCircle":"styles_faCheckCircle__1lMpd","faTimesCircle":"styles_faTimesCircle__1qgLC"};